// extracted by mini-css-extract-plugin
module.exports = {"Title":"Column_Title__135r5","Column":"Column_Column__HBcUP","Links":"Column_Links__3pQdD"};